export const goToPolicyPage = (policyNumber, policyNumberSecondary, multilocationID, locationStartDate) => {
  // Convert the date to the format YYYY-MM-DD
  const date = new Date(locationStartDate);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(date.getDate()).padStart(2, "0"); // Days are zero-based
  const locationStartDateString = `${year}-${month}-${day}`;
  // Replace the dashes with slashes
  const wnd = window.open(
    `#/newpolicies/${policyNumber}/${multilocationID}/${locationStartDateString}`,
    "_blank",
  );
  wnd.onload = function () {
    wnd.document.title = `${policyNumberSecondary}`;
  };
};

export const goToPolicyListLookup = (policyNumberSecondary, companyID) => {
  const wnd = window.open(`#/newpoliciesLookup/${policyNumberSecondary}/${companyID}`, "_blank");
  wnd.onload = function () {
    wnd.document.title = `Policy list ${policyNumberSecondary}`;
  };
};
